import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyChannelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M10.25 10.5C10 11.25 9.33985 11.75 8.5 11.75C7.32513 11.75 6.61036 10.6764 6.35571 9.25M6.35571 9.25C6.28524 8.85526 6.25 8.4335 6.25 8C6.25 7.5665 6.28524 7.14474 6.35571 6.75M6.35571 9.25H5.25M6.35571 9.25H7.75M6.35571 6.75C6.61036 5.32358 7.32513 4.25 8.5 4.25C9.33985 4.25 10 4.75 10.25 5.5M6.35571 6.75H5.25M6.35571 6.75H7.75" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 8,
			r: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.25,
			cy: 1.75,
			r: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.75,
			cy: 1.75,
			r: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.25,
			cy: 14.25,
			r: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.75,
			cy: 14.25,
			r: .75
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 8,
			r: .75
		})
	]
});
export default SvgMoneyChannelIcon;
